import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const locationDetailsReducer = createReducer(initialState, {
  LOCATION_DETAILS_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  LOCATION_DETAILS_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  LOCATION_DETAILS_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default locationDetailsReducer;
